import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';
import CloseIcon from '@mui/icons-material/Close';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from 'react-i18next';
import BasicForm from '../basicForm/basicForm';
import style from './uploadCv.module.scss';
import upload from '../../../Assets/images/bootstrap-upload.png';
import { CV_FILE_ALLOWED_FORMATS, MAX_CV_FILE_SIZE, validationMessages } from '../../../utils/constants';
import ValidationErrorLabel from '../../common/ValidationErrorLabel/ValidationErrorLabel';
import ButtonContainer from '../buttonContainer/buttonContainer';

function UploadCV(props) {
  const [Cv, setCv] = useState(null);
  const [cvName, setCvName] = useState('');
  const initialErrorValidationValue = {
    cv: false
  };
  const [errors, setErrors] = useState([]);
  const [cvReq, setCvReq] = useState(false);
  const { nextHandle, cancel, data, completedProfile, questions, userDataExist, back, step, totalStep, jobTitle } =
    props;
  const user = useSelector((state) => state.user?.profile);

  const { t } = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);

  const validateInputFile = (file) => {
    setCvReq(false);
    const currentErrors = [];
    if (!CV_FILE_ALLOWED_FORMATS.includes(file.name.split('.').pop()))
      currentErrors.push(validationMessage.CV_ALLOWED_FORMATS);
    if (file.size > MAX_CV_FILE_SIZE) currentErrors.push(validationMessage.CV_ALLOWED_FILE_SIZE);
    return currentErrors;
  };

  useEffect(() => {
    if (user && (completedProfile || userDataExist)) {
      setCvName(user?.CvName);
    }

    if (data.Cv) {
      setCv(data.Cv);
      setCvName(data.Cv.name);
    }
  }, [data, user, userDataExist]);

  const replaceFile = (e) => {
    setErrors([]);
    const validationErrors = validateInputFile(e.target.files[0]);

    if (validationErrors.length) {
      setErrors(validationErrors);
      return;
    }

    setCv(e.target.files[0]);
    setCvName(e.target.files[0].name);
  };

  const onDragOver = (ev) => ev.preventDefault();

  const validate = () => {
    const validationObj = {
      ...initialErrorValidationValue
    };

    if (!Cv) {
      validationObj.cv = true;
      setCvReq(true);
    }
    return validationObj;
  };

  const removeAttachment = () => {
    setCv(null);
    setCvName('');
  };

  return (
    <BasicForm
      cancel={cancel}
      title={`${t('jobs.quickapply.userdetailheader')} ${jobTitle}`}
      progress="40"
      subtitle={t('jobs.quickapply.yourCv')}
      step={step}
      totalStep={totalStep}
    >
      <Form.Control
        id="cvUpload"
        placeholder=""
        aria-label="CV Upload"
        style={{ borderBottom: 0, borderLeft: 0, borderRight: 0, padding: 0, height: 0, opacity: 0 }}
        disabled
        className={style.simple_text_field}
      />
      {Cv && cvName && (
        <div className={`${style.namingContainer} ${style.uploadWrapper} p-2`}>
          <div className={style.fileNameWrapper}>
            <AttachFileIcon /> <span className={style.fileName}>{cvName}</span>
          </div>
          <button onClick={removeAttachment} className={style.closeIcon}>
            <CloseIcon />
          </button>
        </div>
      )}
      <button className={style.uploadWrapper} style={{ border: 'none', background: 'none' }} onDragOver={onDragOver}>
        <label className="pb-3" htmlFor="file_picker" style={{ cursor: 'pointer' }}>
          <img className={style.uploadeImage} src={upload} style={{ marginTop: '20px' }} alt="file upload" />
          <div className="">
            Drop files to upload or <span className={style.browseFile}>browse your files</span>
          </div>
          <input
            id="file_picker"
            type="file"
            accept=".pdf,.docx,.doc"
            onChange={replaceFile}
            style={{ display: 'none' }}
          />
        </label>
      </button>
      <div className="pt-2 align-self-center">
        {cvReq && <ValidationErrorLabel message={validationMessage.CV_REQUIRED} />}
      </div>
      <div className="pt-2 align-self-center">
        {!!errors.length && errors.map((err) => <ValidationErrorLabel key={err} message={err} />)}
      </div>
      <ButtonContainer
        actionCall={() => {
          const validationObj = validate();
          const validationWrongValues = Object.values(validationObj).filter(Boolean);
          if (!validationWrongValues.length) {
            nextHandle({ Cv });
          } else {
            const validationWrongEntries = Object.entries(validationObj).filter((v) => Boolean(v[1]));
            const newErrorValidationValue = {};
            validationWrongEntries.forEach((item) => {
              const [key, value] = item;
              newErrorValidationValue[key] = value;
            });
            // setErrorValidation(newErrorValidationValue);
            // setTimeout(() => setErrorValidation(initialErrorValidationValue), 2000);
          }
        }}
        primaryText={t('common.general.back')}
        secondaryText={t('common.general.next')}
        back={back}
      />
    </BasicForm>
  );
}

export default UploadCV;
